import React from 'react';
import './describeProductPageStyle.css';
import './../../components/contentBlock/contentBlockStyles.css'
import useSetSiteLanguage from '../../hooks/useSetSiteLanguage';
import { useParams } from 'react-router-dom';
import Navbar from '../../components/navbar/navbar';
import Footer from '../../components/footer/footer';
import ContentBlock from '../../components/contentBlock/contentBlock';
import ProductTable from '../../components/productTable/productTable';
import H2Title from './../../components/text/h2Title/h2Title'

export default function DescribeProductPage() {
    const params = useParams();
    const siteContent = useSetSiteLanguage();

    console.log("params: ", params)
    const id = params.idundefined

    return (
        <>
            <Navbar data={siteContent?.navbar}/>
            <div className='describe-product-page__container'>
                <H2Title title={siteContent?.productsPage?.products[id]?.name} />
                <ContentBlock 
                    text={siteContent?.productsPage?.products[id]?.summary} 
                    type="photo-right" 
                    photo={siteContent?.productsPage?.products[id]?.photo} 
                />

                <ContentBlock 
                    text={siteContent?.productsPage?.products[id]?.application}
                    title={siteContent?.productsPage?.products[id]?.applicationTitle}
                />


                <div className="content-block__container">
                    <h2 className='content-block__title'>
                        {siteContent?.productsPage?.products[id]?.specificationsTitle}
                    </h2>
                    <ProductTable specifications={siteContent?.productsPage?.products[id]?.specifications} />
                </div>
                    

                <div className="content-block__container">
                    <h2 className='content-block__title'>{siteContent?.productsPage?.products[id]?.mecanicSpecificationsTitle}</h2>
                    <div className='describe-product-page__mecanic-specifications-container'>
                        {siteContent?.productsPage?.products[id]?.mecanicSpecifications.map( (item, index) => (
                            <img className='describe-product-page__mecanic-specifications-photo'
                            src={item} key={index} alt="" />
                        ))}
                    </div>
                </div>

                <div className="content-block__container">
                    <h2 className='content-block__title'>{siteContent?.productsPage?.products[id]?.graphsTitle}</h2>
                    <div className='describe-product-page__graphs-container'>
                        {siteContent?.productsPage?.products[id]?.graphs.map( (item, index) => (
                            <div className='describe-product-page__graphs-wrapper'>   
                                <img className='describe-product-page__graphs-photo'
                                src={item.photo} key={index} alt="" />
                                <p className='describe-product-page__graphs-description'>{item.text}</p>
                            </div>
                        ))}
                    </div>
                </div>

            </div>
            <Footer />
        </>
    );
}
